import Styles from '../../../WizardsDrawerV4.module.scss'
import { LevelProps } from '../../../Types'
import { LEVEL_CARDS } from '../../../Constants'
import { LevelPage } from '../../LevelPage'
import { ArrowRight } from 'blaze-ui/icons'

export const LinkedInPost = (props: LevelProps) => {
  const linkedInCards = LEVEL_CARDS.L4.LINKEDIN_POST_OPTIONS.map((card) => ({
    ...card,
    bottomLeftIcon: <ArrowRight size={28} color="var(--dark-40)" />,
  }))

  return (
    <LevelPage
      {...props}
      heading="What kind of post do you want to make?"
      imgScale={0.65}
      textWidth="65%"
      cards={linkedInCards}
      cardSize="big"
      className={Styles.linkedInPost}
    />
  )
}
